import React, { Fragment, useEffect, useState } from 'react';
import { Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBullhorn,
  faEye,
  faLink,
  faClipboardList
} from '@fortawesome/free-solid-svg-icons';
import { useAssignmentContext } from '../context';
import Modal from '../../../components/Modal';
import {
  useDeletePublicAssignmentMutation,
  useGetPublicAssignmentPropertiesMutation,
  useGetPublicAssignmentsMutation
} from '../../../features/authentication/authApiSlice';
import PropTypes from 'prop-types';
import AssignmentLinksModal from '../../../components/AssignmentLinksModal/index';
import AssignmentCreateContent from './AssignmentCreateContent';
import NoAssignment from '../../../assets/images/NoAssignment.png';
import ConfirmationModal from '../../../components/ConfirmationPopUp';
import CustomToast from '../../../components/Toast';
import { faArrowDown } from '@fortawesome/free-solid-svg-icons';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import PublicSetPreviewModal from '../pages/AssignmentsAndActivities/Components/modals/PublicSetPreviewModal';
import PropertiesModal from './PropertiesModal';
import { faTrashAlt } from '@fortawesome/pro-solid-svg-icons';

const CurrentAssignmentsHeader = () => {
  const [viewPublicAssignmentsModal, setViewPublicAssignmentsModal] = useState(false);
  const [openAssignmentProperties, setOpenAssignmentProperties] = useState(false);
  const [viewAssignmentsLinksModal, setViewAssignmentsLinksModal] = useState(false);
  const [viewPublicSetModal, setViewPublicSetModal] = useState(false);
  const [assignmentPropertiesTitle, setAssignmentPropertiesTitle] = useState();
  const [viewPublicSetTitle, setViewPublicSetTitle] = useState();
  const allAssignmentsData = useAssignmentContext();
  const [allPublicAssignments, setAllPublicAssignments] = useState([]);
  const [publicAssignmentProperties, setPublicAssignmentProperties] = useState({});
  const [getPublicAssignments] = useGetPublicAssignmentsMutation();
  const [getPublicAssignmentProperties] = useGetPublicAssignmentPropertiesMutation();
  const [deletePublicAssignment] = useDeletePublicAssignmentMutation();
  const [isLoading, setIsLoading] = useState(false);
  const [isDeleteInProgress, setIsDeleteInProgress] = useState(false);
  const [openDeleteConfirmation, setOpenDeleteConfirmation] = useState(false);
  const [deletePublicAssignmentId, setDeletePublicAssignmentId] = useState('');
  const [deletepublicAssignmentName, setDeletedAssignment] = useState();
  const [isWaiting, setIsWaiting] = React.useState(false);
  const [selectedPublicAssignmentId, setSelectedPublicAssignmentId] = useState(null);

  const getAllPublicAssignmentsAsync = async () => {
    try {
      setIsLoading(true);
      const options = {
        skip: 0,
        take: 100
      };
      const response = await getPublicAssignments(options).unwrap();
      setAllPublicAssignments(response);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  const getPublicAssignmentPropertiesAsync = async (id) => {
    try {
      setIsWaiting(true);
      const option = {
        assignmentId: id
      };
      const response = await getPublicAssignmentProperties(option).unwrap();
      setPublicAssignmentProperties(response);
      setIsWaiting(false);
    } catch (error) {
      setIsWaiting(false);
      console.log(error);
    }
  };

  const deleteAssignmentHandler = (deleteAssignmentId, assignmentName) => {
    setDeletedAssignment(assignmentName);
    setDeletePublicAssignmentId(deleteAssignmentId);
    setOpenDeleteConfirmation(true);
  };

  const deleteAssignment = async (id) => {
    if(isDeleteInProgress)
      return;

    setIsDeleteInProgress(true);
    try {
      const options = {
        assignmentId: id
      };
      const response = await deletePublicAssignment(options).unwrap();
      setIsDeleteInProgress(false);
      if (response) {
        CustomToast('Assignment has been deleted', 'success');
        setOpenDeleteConfirmation(false);
        getAllPublicAssignmentsAsync();
      }
    } catch (error) {
      console.log(error);
      setIsDeleteInProgress(false);
    }
  };

  const viewAssignmentPropertiesHandler = (titleId , description) => {
    setPublicAssignmentProperties([]);
    if (!isWaiting) {
      setOpenAssignmentProperties(true);
      setSelectedPublicAssignmentId(titleId);
      getPublicAssignmentPropertiesAsync(titleId);
      setAssignmentPropertiesTitle(description);
    }
  };

  const viewPublicSetHandler = (id,description) => {
    setSelectedPublicAssignmentId(id);
    setViewPublicSetTitle(description);
    setViewPublicSetModal(true);
  };

  useEffect(() => {
    if(viewPublicAssignmentsModal)
      getAllPublicAssignmentsAsync();
  }, [viewPublicAssignmentsModal]);

  const modal = (
    <>
      {/* view public Assignments modal */}
      <Modal
        contentWidth="1200px"
        isOpen={viewPublicAssignmentsModal}
        titleName={'Assignments You’ve Published'}
        onClose={() => setViewPublicAssignmentsModal(false)}>
        <div className="public-assignments">
          <div className="">
            <table className="table reportTable">
              <thead className='thead-fixed'>
                <tr>
                  <th className='fw-medium'>Course</th>
                  <th className='fw-medium'>Assignment Name</th>
                  <th className='fw-medium text-center'>Question Count</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  <>
                    {[...Array(10)].map((_, index) => (
                      <tr key={index}>
                        <td>
                          <Skeleton />
                        </td>
                        <td>
                          <Skeleton />
                        </td>
                        <td>
                          <Skeleton />
                        </td>
                        <td>
                          <div className="d-flex justify-content-end gap-2">
                            <button className="btn grid-icon-btn info-icon-btn">
                              <Skeleton />
                            </button>
                            <button className="btn grid-icon-btn primary-icon-btn">
                              <Skeleton />
                            </button>
                            <button className="btn grid-icon-btn danger-icon-btn">
                              <Skeleton />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </>
                ) : (
                  <>
                    {allPublicAssignments.map((item) => (
                      <tr key={`public-assignment-list-${item.publicAssignmentID}`}>
                        <td> {item.courseName}</td>
                        <td> {item.description}</td>
                        <td className='text-center'> {item.totalQuestions} </td>
                        <td>
                          <div className="d-flex justify-content-end gap-2">
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip className="custom-tooltip">View Properties</Tooltip>
                              }>
                              <button
                                className="btn grid-icon-btn info-icon-btn"
                                onClick={() =>
                                  viewAssignmentPropertiesHandler(item.publicAssignmentID, item.description)
                                }>
                                {' '}
                                <FontAwesomeIcon icon={faClipboardList}  className='fs-6' />
                              </button>
                            </OverlayTrigger>
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip className="custom-tooltip">View Set</Tooltip>
                              }>
                              <button
                                className="btn grid-icon-btn primary-icon-btn"
                                onClick={() => viewPublicSetHandler(item.publicAssignmentID,item.description)}>
                                {' '}
                                <FontAwesomeIcon icon={faEye}  className='fs-6' />
                              </button>
                            </OverlayTrigger>
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip className="custom-tooltip">
                                      Delete
                                </Tooltip>
                              }>
                              <button disabled ={item.isDelete === 0} className="btn grid-icon-btn danger-icon-btn">
                                {' '}
                                <FontAwesomeIcon
                                  icon={faTrashAlt}
                                  className='fs-6'
                                  onClick={() =>
                                    deleteAssignmentHandler(
                                      item.publicAssignmentID,
                                      item.description
                                    )
                                  }
                                />
                              </button>
                            </OverlayTrigger>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </>
                )}
              </tbody>

              <div className="scrolldown-btn-public">
                <span>Scroll Down</span>
                <FontAwesomeIcon icon={faArrowDown} />
              </div>
            </table>
          </div>
        </div>
      </Modal>
      <ConfirmationModal
        isOpen={openDeleteConfirmation}
        onClose={() => setOpenDeleteConfirmation(false)}
        onSave={() => deleteAssignment(deletePublicAssignmentId)}
        contentWidth={'35%'}
        buttonPosition={'center'}
        titleName={'Delete Confirmation'}
        content={`Are you sure that you want to delete the Assignment named <b>${deletepublicAssignmentName} </b> ? THIS CANNOT BE RESTORED!`}
        cancelButton={'No'}
        confirmButton={'Yes'}
      />
      <PropertiesModal
        title={assignmentPropertiesTitle}
        properties={publicAssignmentProperties}
        isLoading={isWaiting}
        openProperties={openAssignmentProperties}
        setOpenProperties={setOpenAssignmentProperties}
        assignmentId = {selectedPublicAssignmentId}
        isPublicAssignment={true}
      /> 
      
      <PublicSetPreviewModal
        viewPublicSetModal={viewPublicSetModal}
        viewPublicSetTitle={viewPublicSetTitle}
        onClose={()=>setViewPublicSetModal(false)}
        showPrintButton={true}
        selectedPublicAssignmentId={selectedPublicAssignmentId}
      />
      {/* View Assignments Link Modal */}
      <AssignmentLinksModal
        showAssignmentLinksModal={viewAssignmentsLinksModal}
        setShowAssignmentLinksModal={setViewAssignmentsLinksModal}
        showAssignedViaFilter={true}
      />
    </>
  );

  const LayOut = ({ children }) => {
    return (
      <Row className="align-items-center mb-4">
        <Col className="col-lg-5">
          <h3 className="primary-title mb-lg-0">
            Current Assignments{' '}
            {allAssignmentsData.isAssignmentsAvailable && (
              <small className="opacity-50">({allAssignmentsData.noOfAssignments})</small>
            )}
          </h3>
        </Col>
        <Col className="col-lg-7 d-flex flex-wrap gap-3 justify-content-between justify-content-lg-end">
          <button
            onClick={() => setViewPublicAssignmentsModal(!viewPublicAssignmentsModal)}
            className="btn-link primary-link">
            <FontAwesomeIcon icon={faBullhorn} /> View Published Assignments
          </button>
          <button
            onClick={() => setViewAssignmentsLinksModal(!viewAssignmentsLinksModal)}
            className="btn-link primary-link">
            <FontAwesomeIcon icon={faLink} /> View Assignment Links
          </button>
        </Col>
        {children}
        {!allAssignmentsData.isAssignmentsAvailable && (
          <div className="no-assignments-card my-4">
            <div className="text-center no-assignments-icon mb-5">
              <img src={NoAssignment} className="my-4" />
              <p className="mb-4">
                The assignment list is currently empty, use the below form to create a new
                assignment.
              </p>
            </div>
            <AssignmentCreateContent showBrowseContent={false} showTitle={true} fromAssignments={true}/>
          </div>
        )}
      </Row>
    );
  };

  LayOut.propTypes = {
    children: PropTypes.node
  };

  return (
    <Fragment>
      <LayOut>{modal}</LayOut>
    </Fragment>
  );
};

CurrentAssignmentsHeader.propTypes = {
  children: PropTypes.node
};

export default CurrentAssignmentsHeader;
